import { buildQueryContext } from '@superset-ui/core';
import { EchartsNestedPieFormData } from './types';

export default function buildQuery(formData: EchartsNestedPieFormData) {
    const { metric, sort_by_metric, groupby, groupby_inner } = formData;
    return buildQueryContext(formData, baseQueryObject => [
        {
            ...baseQueryObject,
            ...(sort_by_metric && { orderby: [[metric, false]] }),
            columns: [groupby, groupby_inner]
        },
    ]);
}